/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerNoteService = {
  async getByCustomerCode(code) {
    const requestScreenData = {
      url: "api/CustomerNote",
      top: "1",
      filter: `CustomerCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/CustomerNote",
      expand: "Customer($select=Code,Name)",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, customerNote) {
    var payload = customerNote;
    var url = "api/Save_CustomerNote";

    if (mode == "create") {
      return await ApiService.post(url, payload, "Guid");
    } else {
      return await ApiService.put(url, customerNote.RecordId, payload, "Guid");
    }
  },
  async delete(customerNote) {
    var payload = customerNote;
    var url = "api/Save_CustomerNote";

    return await ApiService.delete(url, customerNote.RecordId, "Guid");
  },
};

export { CustomerNoteService };
